module.exports = __webpack_public_path__ + "static/img/kaipiaozhong@3x354f8a8.png";